<template>
  <w-dialog v-model="visible" :title="title" width="600px" destroy-on-close @ok="selectOk">
    <div class="picker">
      <div class="picker-wrap">
        <div class="candidate" v-loading="loading">
          <div v-if="type !== 'role'">
            <el-input v-model="search" @input="searchUser" size="small"
                      clearable placeholder="搜索人员，支持拼音、姓名" prefix-icon="el-icon-search"/>
            <div v-show="!showUsers">
              <el-collapse-transition>
                <ellipsis v-if="deptStackStr" hoverTip style="margin-top: 12px; color: #666;" :content="deptStackStr">
                  <i slot="pre" class="el-icon-office-building"></i>
                </ellipsis>
              </el-collapse-transition>
              <div style="margin-top: 12px">
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange" :disabled="!multiple">全选</el-checkbox>
                <span v-show="deptStack.length > 0" class="top-dept" @click="beforeNode"><i class="el-icon-top"></i>上一级</span>
              </div>
            </div>
          </div>
          <div class="role-header" v-else>
            <div>系统角色</div>
          </div>
          <div class="member-wrap">
            <div class="member-items">
              <template v-if="members.length">
                <AppScrollbar style="height: 100%">
                  <div v-for="(member, index) in members" :key="index" :class="memberItemClass(member)" @click="selectChange(member)">
                    <el-checkbox v-model="member.selected" :disabled="disableDept(member)" @change="selectChange(member)"></el-checkbox>
                    <div v-if="member.type === 'dept'">
                      <i class="el-icon-folder-opened"></i>
                      <span class="name">{{ member.name }}</span>
                      <span @click.stop="nextNode(member)" :class="`next-dept${member.selected ? '-disable':''}`">
                      <span class="down"><i class="el-icon-bottom"></i>下级</span>
                    </span>
                    </div>
                    <div v-else-if="member.type === 'user'" style="display: flex; align-items: center">
                      <el-avatar :size="35" :src="member.avatar" v-if="$isNotEmpty(member.avatar)"/>
                      <span v-else class="avatar">{{getShortName(member.name)}}</span>
                      <span class="name">{{ member.name }}</span>
                    </div>
                    <div style="display: inline-block" v-else>
                      <i class="el-icon-files"></i>
                      <span class="name">{{ member.name }}</span>
                    </div>
                  </div>
                </AppScrollbar>
              </template>
              <template v-else>
                <Hint :icon="false">
                  <span>似乎没有数据</span>
                </Hint>
              </template>
            </div>
          </div>
        </div>
        <div class="selected">
          <div class="count">
            <span>已选 {{ select.length }} 项</span>
            <span @click="clearSelected">清空</span>
          </div>
          <div class="member-wrap">
            <div class="member-items">
              <template v-if="select.length">
                <AppScrollbar style="height: 100%">
                  <div v-for="(member, index) in select" :key="index" :class="memberItemClass(member)" >
                    <div v-if="member.type === 'dept'">
                      <i class="el-icon-folder-opened"></i>
                      <span style="position: static" class="name">{{ member.name }}</span>
                    </div>
                    <div v-else-if="member.type === 'user'" style="display: flex; align-items: center">
                      <el-avatar :size="35" :src="member.avatar" v-if="$isNotEmpty(member.avatar)"/>
                      <span v-else class="avatar">{{getShortName(member.name)}}</span>
                      <span class="name">{{ member.name }}</span>
                    </div>
                    <div v-else>
                      <i class="el-icon-files"></i>
                      <span class="name">{{ member.name }}</span>
                    </div>
                    <i class="el-icon-close" @click="noSelected(index)"></i>
                  </div>
                </AppScrollbar>
              </template>
              <template v-else>
                <Hint :icon="false">
                  <span>请点击左侧列表选择数据</span>
                </Hint>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script>
import WDialog from './WDialog'
import AppScrollbar from '../../AppScrollbar'
import Hint from '../../Hint'
export default {
  name: 'MemberPicker',
  components: {
    WDialog,
    AppScrollbar,
    Hint
  },
  props: {
    title: {
      default: '请选择',
      type: String
    },
    type: {
      // member选择部门/人员  user-选人  dept-选部门 role-选角色
      default: 'user',
      type: String
    },
    // 是否多选
    multiple: {
      default: false,
      type: Boolean
    },
    selected: {
      default: () => {
        return []
      },
      type: Array
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      checkAll: false,
      nowDeptId: null,
      isIndeterminate: false,
      searchUsers: [],
      nodes: [],
      select: [],
      search: '',
      deptStack: []
    }
  },
  computed: {
    deptStackStr () {
      return String(this.deptStack.map(v => v.name)).replaceAll(',', ' > ')
    },
    members () {
      return !this.search || this.search.trim() === '' ? this.nodes : this.searchUsers
    },
    showUsers () {
      return this.search || this.search.trim() !== ''
    }
  },
  methods: {
    getMemberTree ({type, deptId}) {
      return this.$ajax({
        url: `/workspace/manager/flow/configure/approval/member/${type}`,
        method: 'post',
        data: this.$qs.stringify({
          deptId
        })
      })
    },
    getUserByName (params) {
      return this.$ajax({
        url: '/workspace/manager/flow/configure/approval/member/user',
        method: 'post',
        data: this.$qs.stringify(params)
      })
    },
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.init()
        this.getMemberList()
      })
    },
    memberItemClass (member) {
      return {
        'member-item': true,
        'member-dept-item': member.type === 'dept',
        'member-user-item': member.type === 'user',
        'member-role-item': member.type === 'role'
      }
    },
    disableDept (node) {
      return this.type === 'user' && node.type === 'dept'
    },
    getMemberList () {
      this.loading = true
      this.getMemberTree({deptId: this.nowDeptId, type: this.type}).then(response => {
        this.loading = false
        this.nodes = response.data.result || []
        this.selectToLeft()
      }).catch(err => {
        this.loading = false
        this.$message.error(err.response.data)
      })
    },
    getShortName (name) {
      if (name) {
        return name.length > 2 ? name.substring(1, 3) : name
      }
      return '**'
    },
    searchUser () {
      let userName = this.search.trim()
      this.searchUsers = []
      this.loading = true
      this.getUserByName({userName: userName}).then(response => {
        this.loading = false
        this.searchUsers = response.data.result || []
        this.selectToLeft()
      }).catch(_err => {
        this.loading = false
        this.$message.error('接口异常')
      })
    },
    selectToLeft () {
      let nodes = this.search.trim() === '' ? this.nodes : this.searchUsers
      nodes.forEach(node => {
        for (let i = 0; i < this.select.length; i++) {
          if (this.select[i].id === node.id) {
            node.selected = true
            break
          } else {
            node.selected = false
          }
        }
      })
    },
    selectChange (node) {
      if (node.selected) {
        this.checkAll = false
        for (let i = 0; i < this.select.length; i++) {
          if (this.select[i].id === node.id) {
            this.select.splice(i, 1)
            break
          }
        }
        node.selected = false
      } else if (!this.disableDept(node)) {
        node.selected = true
        let nodes = this.search.trim() === '' ? this.nodes : this.searchUsers
        if (!this.multiple) {
          nodes.forEach(nd => {
            if (node.id !== nd.id) {
              nd.selected = false
            }
          })
        }
        if (node.type === 'dept') {
          if (!this.multiple) {
            this.select = [node]
          } else {
            this.select.unshift(node)
          }
        } else {
          if (!this.multiple) {
            this.select = [node]
          } else {
            this.select.push(node)
          }
        }
      }
    },
    noSelected (index) {
      let nodes = this.nodes
      for (let f = 0; f < 2; f++) {
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].id === this.select[index].id) {
            nodes[i].selected = false
            this.checkAll = false
            break
          }
        }
        nodes = this.searchUsers
      }
      this.select.splice(index, 1)
    },
    handleCheckAllChange () {
      this.nodes.forEach(node => {
        if (this.checkAll) {
          if (!node.selected && !this.disableDept(node)) {
            node.selected = true
            this.select.push(node)
          }
        } else {
          node.selected = false
          for (let i = 0; i < this.select.length; i++) {
            if (this.select[i].id === node.id) {
              this.select.splice(i, 1)
              break
            }
          }
        }
      })
    },
    nextNode (node) {
      this.nowDeptId = node.id
      this.deptStack.push(node)
      this.getMemberList()
    },
    beforeNode () {
      if (this.deptStack.length === 0) {
        return
      }
      if (this.deptStack.length < 2) {
        this.nowDeptId = null
      } else {
        this.nowDeptId = this.deptStack[this.deptStack.length - 2].id
      }
      this.deptStack.splice(this.deptStack.length - 1, 1)
      this.getMemberList()
    },
    recover () {
      this.select = []
      this.nodes.forEach(nd => {
        nd.selected = false
      })
    },
    selectOk () {
      this.$emit('ok', Object.assign([], this.select.map(v => {
        v.avatar = undefined
        return v
      })))
      this.visible = false
      this.recover()
    },
    clearSelected () {
      this.$confirm('您确定要清空已选中的项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.recover()
      })
    },
    close () {
      this.$emit('close')
      this.recover()
    },
    init () {
      this.checkAll = false
      this.nowDeptId = null
      this.deptStack = []
      this.nodes = []
      this.select = Object.assign([], this.selected)
      this.selectToLeft()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../../../../styles/color" as *;

.picker {
  height: 430px;
  position: relative;
  padding: 15px;
  text-align: left;
  &>.picker-wrap {
    position: relative;
    height: 100%;
    display: flex;
    align-items: stretch;
    gap: 12px;
  }

  .candidate, .selected {
    background-color: #fff;
    border: 1px solid #e8e8e8;
    flex: 1;
    display: flex;
    justify-content: stretch;
    flex-direction: column;
    overflow: hidden;
  }

  .candidate {
    .role-header{
      padding: 10px !important;
      margin-bottom: 5px;
      border-bottom: 1px solid #e8e8e8;
    }

    .top-dept{
      margin-left: 20px;
      color: $set-primary-color;
      font-size: 13px;
      cursor: pointer;
      i {
        margin-right: 4px;
      }
    }

    .next-dept {
      float: right;
      color: $set-primary-color;
      cursor: pointer;
    }

    .next-dept-disable {
      float: right;
      color: #8c8c8c;
      cursor: not-allowed;
    }

    &>div:first-child {
      padding: 10px;
    }
  }

  .member-wrap {
    flex: auto;
    position: relative;

    .member-items {
      position: absolute;
      inset: 0;

      .el-icon-close {
        position: absolute;
        right: 5px;
        cursor: pointer;
        font-size: larger;
      }
      .member-dept-item {
        padding: 10px 5px;

        &>div {
          display: inline-block;

          &>span:last-child {
            position: absolute;
            right: 5px;
          }
        }
      }

      .member-role-item {
        display: flex;
        align-items: center;
        padding: 10px 5px;
      }

      ::v-deep .member-user-item {
        display: flex;
        align-items: center;
        padding: 5px;

        &>div {
          display: inline-block;
        }

        .avatar {
          width: 35px;
          text-align: center;
          line-height: 35px;
          background: $set-primary-color;
          color: white;
          border-radius: 50%;
        }
      }

      ::v-deep .member-item {
        margin: 0 5px;
        border-radius: 5px;
        position: relative;

        .el-checkbox {
          margin-right: 10px;
        }

        .name {
          margin-left: 5px;
        }

        .down {
          font-size: 13px;
          i {
            margin-right: 4px;
          }
        }

        &:hover {
          background: #f1f1f1;
        }
      }
    }
  }
}

.selected {
  .count {
    padding: 10px;
    display: inline-block;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;
    &>span:nth-child(2) {
      float: right;
      color: #c75450;
      cursor: pointer;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}
</style>
